<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="130px">
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="手机号码/账号"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.phone"
                  placeholder="请输入手机号码/账号进行检索"
                ></el-input>
              </el-form-item>
            </el-col>
            
            <el-col :span="6">
              <el-form-item
                label="商品状态"
                prop="status"
                style="width: 80%"
              >
                <el-select
                  clearable filterable
                  v-model="searchForm.status"
                  placeholder="请选择商品状态"
                >
                  <el-option :value="0" label="未使用"></el-option>
                  <el-option :value="1" label="已使用"></el-option>
                  <el-option :value="2" label="已过期"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
           
            <el-col :span="8">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px"></div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="giftName" label="兑换商品名称" align="center">
        </el-table-column>
        
        <el-table-column prop="phone" label="账号/手机号码" align="center">
        </el-table-column>
        <el-table-column prop="giftIntegrals" label="消耗积分" align="center">
        </el-table-column>
        
        <el-table-column prop="createTime" label="兑换时间" align="center">
        </el-table-column>
        <el-table-column prop="status" label="商品状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 0" type="warning">未使用</el-tag>
            <el-tag v-if="scope.row.status == 1" type="success">已使用</el-tag>
            <el-tag v-if="scope.row.status == 2" type="info">已过期</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="verifyTime" label="核销时间" align="center">
        </el-table-column>      
        <el-table-column prop="validTime" label="有效日期" align="center">
          <template slot-scope="scope">
            {{ scope.row.validTime.split(' ')[0] }}
          </template>
        </el-table-column>
        
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="seeDetail(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
       
      </div>
      <!-- 新增模态框 -->
      <el-dialog
        :title="diaTitle"
        :visible.sync="isAddModals"
        width="50%"
        :close-on-click-modal="false"
      >
        <el-form
          ref="form"
          :model="addData"
          label-width="120px"
          :rules="addDataRules"
          id="printTest"
          label-position="left"
          style="margin: 0 20px;"
        >
          <el-form-item label="兑换商品名称：">
            <div>{{ addData.giftName }}</div>
          </el-form-item>
          <el-form-item label="账号/手机号码：">
            <div>{{ addData.phone }}</div>
          </el-form-item>
          <el-form-item label="消耗积分：">
            {{ addData.giftIntegrals }}
          </el-form-item>
          <el-form-item label="兑换时间：">
            {{ addData.verifyTime }}
          </el-form-item>
          <el-form-item label="失效日期：">
            {{ addData.validTime && addData.validTime.split(' ')[0] }}
          </el-form-item>
          <el-form-item label="商品状态：">
            <el-tag v-if="addData.status == 0" type="warning">未使用</el-tag>
            <el-tag v-if="addData.status == 1" type="success">已使用</el-tag>
            <el-tag v-if="addData.status == 2" type="info">已过期</el-tag>
          </el-form-item>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isAddModals = false">关闭</el-button>
          </span>
        </el-form>
        
      </el-dialog>
    </div>
  </div>
</template>

<script>
import store from "@/store";
export default {
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      isShowloading: false,
      isAddModal: false,
      btnLoading: false,
      isAddModals: false,
      personList: [],
      addData: {
        manageUserId:"",
        subscribeTime:""
      },
      addDataRules: {
        
      },
      personList: [],
      searchForm: {
        orderWorkNo: "",
      },
      diaTitle:'详情'
      
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    seeDetail(row) {
      this.$Apis.giftOrderDetail({
        id:row.id
      }).then(res=>{
        if(res.code == 200){
          this.addData = res.data
          this.diaTitle = '详情'
          this.isAddModals = true;
          
        }
      })
     
    },
    onLoad(ind) {
      this.isShowloading = true;
      this.currentPage = ind == 1 ? 1 : this.currentPage
      let page = {
        current: this.currentPage,
        size: this.pageSize,
        ...this.searchForm
      };
      this.tableData = [];
      this.$Apis.giftOrderGetList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
      
    },
  },
};
</script>

<style  scoped>
/deep/.el-input.is-disabled .el-input__inner{
  color: #333;
  font-weight: bold;
  border: none;
  background: #fff;
}
/deep/ .el-textarea.is-disabled .el-textarea__inner{
  color: #333;
  font-weight: bold;
  border: none;
  background: #fff;
}
.flex{
  display: flex;
  align-items: center;
  height: 40px;
}
.main{
  padding-top: 30px;
  border-top: 1px solid #eee;
}
.mtitle{
  font-size: 18px;
  /* padding-left: 40px; */
  font-weight: bold;

}
.dialog-footer{
  display: flex;
  justify-content: center;
}
</style>